



























import { Vue, Component } from "@/shared/vuepack";
import { IdentityProofingOptionType } from "@/shared/types";
import { useCredentialFlowStore } from "@/employee/store/credentialFlow";

@Component
export default class AlternateLoginCard extends Vue {
  credentialFlowStore = useCredentialFlowStore();

  selectedOption: any = null;

  onOptionChanged (optionType: any) {
    this.$emit("change", optionType);
  }

  identityOptionDisplayName (optionType: IdentityProofingOptionType) {
    switch (optionType) {
      case IdentityProofingOptionType.Email:
        return "Email";
      case IdentityProofingOptionType.Sms:
        return "SMS";
      case IdentityProofingOptionType.Voice:
        return "Phone";
      case IdentityProofingOptionType.DataEntry:
        return "Data Entry";
      default:
        return "none";
    }
  }
}
